import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import './login.css';
import { RESET_PASSWORD } from "../../redux/constant";
import { ButtonLoader } from '../../component/common/Loader';
import PasswordInput from '../../component/common/PasswordInput';

const ConfirmPassword = ({ phoneNo, restaurantId }) => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const otpForPhone = useSelector((state) => state?.admin?.flags?.otpForPhone);
    const loading = useSelector((state) => state.admin.loading); 

    const dispatch = useDispatch();
    // 
    const handleConfirmPassword = () => {
        setError('');
        if (password && confirmPassword) {
            if (password === confirmPassword) {
                if (password.length < 8 || !/[A-Z]/.test(password) || !/[0-9]/.test(password) || !/[!@#$%^&*]/.test(password)) {
                    setError('Password must be at least 8 characters long and include an uppercase letter, a number, and a special character.');
                    return;
                }
                // todo: get phone number from state which is set in OtpInput
                const dto = {
                    userId: restaurantId?.userId,
                    restaurantId: restaurantId?.restaurantOrBranchId,
                    contactNumber: phoneNo,
                    newPassword:password,
                    confirmPassword: confirmPassword
                }
                dispatch({ type: RESET_PASSWORD, payload: dto });

            } else {
                setError('Passwords do not match.');
            }
        } else {
            setError('Please fill in both password fields.');
        }
    };

    return (
        <>
            {error && (
                <div className="error-message" style={{ color: "var(--ui-danger-text)", marginBottom: '10px' }}>
                    {error}
                </div>
            )}
            <div>
                <PasswordInput
                    required
                    className="loginInput"
                    id="password"
                    aria-label="New password"
                    autoComplete="new-password"
                    toggleLabel="new password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    placeholder="Enter password"
                />
            </div>
            <div>
                <PasswordInput
                    required
                    className="loginInput"
                    id="confirmPassword"
                    aria-label="Confirm password"
                    autoComplete="new-password"
                    toggleLabel="confirm password"
                    value={confirmPassword}
                    onChange={e => setConfirmPassword(e.target.value)}
                    placeholder="Confirm password"
                />
            </div>

            <button onClick={handleConfirmPassword} className="full-btn">
                {loading ? <ButtonLoader label="Saving password..." /> : "Confirm Password"}
            </button>
            <div className="password-requirements">
                <p>Password must be at least 8 characters long and include:</p>
                <ul className="no-bullets">
                    <li>At least one uppercase letter</li>
                    <li>At least one number</li>
                    <li>At least one special character (e.g., !@#$%^&*)</li>
                </ul>
            </div>
        </>
    )
}

export default ConfirmPassword;
